<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Button, Modal, Container, TimeWheel, IconButton } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { saveCustomTimer, type QuickControlEntry } from 'src/helpers/quick_control_helper';

	export let showAddModal: boolean = false;
	export let selectedTime: QuickControlEntry = { hr: '00', min: '00', sec: '00' };
	export let deviceId: string = '';
	export let isEditMode: boolean = false;

	const dispatch = createEventDispatcher();

	const onCloseModal = () => {
		selectedTime = { hr: '00', min: '00', sec: '00' };
		showAddModal = false;
	};

	const addNewEntry = async () => {
		if (deviceId) {
			await saveCustomTimer(deviceId, {
				hr: selectedTime.hr,
				min: selectedTime.min,
				sec: selectedTime.sec,
			});
			dispatch('save');
		}
		showAddModal = false;
	};

	const handleDelete = () => {
		dispatch('delete');
	};
</script>

<Modal
	on:close={() => {
		onCloseModal();
	}}
	showModal={showAddModal}
	title={isEditMode
		? $format('title_edit_time_entry', { default: 'Edit time entry' })
		: $format('title_add_time_entry', { default: 'Add new time entry' })}
>
	<Container slot="content">
		<div class="d-flex align-items-center">
			<TimeWheel
				a11yProps={{
					inputAriaLabel: $format('label_time_wheel_input', { default: 'Time wheel input' }),
					buttonAriaLabel: $format('label_time_wheel_button', {
						default: 'Time wheel button',
					}),
					secondsColumnAriaLabel: $format('label_time_wheel_seconds_column', {
						default: 'Time wheel seconds column',
					}),
					secondPrefixAriaLabel: $format('label_time_wheel_second_prefix', {
						default: 'Time wheel second prefix',
					}),
					msColumnAriaLabel: $format('label_time_wheel_ms_column', {
						default: 'Time wheel ms column',
					}),
					msPrefixAriaLabel: $format('label_time_wheel_ms_prefix', {
						default: 'Time wheel ms prefix',
					}),
					hoursColumnAriaLabel: $format('label_time_wheel_hours_column', {
						default: 'Time wheel hours column',
					}),
					hourPrefixAriaLabel: $format('label_time_wheel_hour_prefix', {
						default: 'Time wheel hour prefix',
					}),
					minutesColumnAriaLabel: $format('label_time_wheel_minutes_column', {
						default: 'Time wheel minutes column',
					}),
					minutePrefixAriaLabel: $format('label_time_wheel_minute_prefix', {
						default: 'Time wheel minute prefix',
					}),
				}}
				id="time-wheel-1dqksc7"
				class="mb-s"
				enableMilliseconds={false}
				observePopoverElement={false}
				bind:selectedHour={selectedTime.hr}
				bind:selectedMinute={selectedTime.min}
				bind:selectedSecond={selectedTime.sec}
				maxHours={128}
				texts={{
					title: $format('settings_title_timer', {
						default: 'Timer',
					}),
					hours: $format('timer_text_hr', {
						default: 'hr',
					}),
					minutes: $format('timer_text_min', {
						default: 'min',
					}),
					seconds: $format('timer_text_sec', {
						default: 'sec',
					}),
				}}
			/>
			{#if isEditMode}
				<IconButton
					class="ml-s mb-s"
					shape="circle"
					icon="fas fa-trash"
					variant="danger"
					on:click={handleDelete}
					aria-label={$format('button_delete_timer', { default: 'Delete timer' })}
				/>
			{/if}
		</div>
	</Container>
	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			on:click={() => {
				onCloseModal();
			}}
		>
			{$format(`button_cancel`, { default: 'Cancel' })}
		</Button>
		<Button
			disabled={selectedTime.hr?.startsWith('00') &&
				selectedTime.min?.startsWith('00') &&
				selectedTime.sec?.startsWith('00')}
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			on:click={addNewEntry}
		>
			{$format(isEditMode ? 'button_save' : 'button_add', {
				default: isEditMode ? 'Save' : 'Add',
			})}
		</Button>
	</div>
</Modal>
